export const environment = {
    sentryRelease: 'git-9d73b8c',
    sentryEnvironment: 'PRD',
    apiUrl: '/api/',
    key: 'XodujCJIBr',
    allowedHosts: [
        'http://localhost:4200',
        'http://localhost:9000',
        // head
        'https://oms5.head.com',
        'https://oms5.head-test.com',
        //mares
        'https://oms5.mares.com',
        'https://oms5.mares-test.com',
        //zoggs
        'https://oms5.zoggs.com',
        'https://oms5.zoggs-test.com',
        //partner
        'https://partner.head-test.com',
        'https://partner.head.com',
        //divessi
        'https://oms5.divessi.com',
        'https://oms5.divessi-test.com',
        //indigo
        'https://indigo-oms5.head-test.com',
        'https://oms5.indigo.ski',
        //m2Apps
        'https://m2apps.head-test.com',
        'https://m2apps.head.com',
    ],
};
